import createFlexContainer from './helpers/createFlexContainer';

var defaultColumnStyle = { flexDirection: 'column' };

export default createFlexContainer(defaultColumnStyle, 'Column');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-app/node_modules/@dhis2/d2-ui-core/build/es/layout/Column.component.js
// module id = 1977
// module chunks = 0